import { store } from '@redux/store'
import { AUTH } from '@const'

export function checkValid(id) {
    const auth = store.getState().auth
    const userInfo = auth ? auth.userInfo : null

    if (!userInfo || !userInfo['authorization_list']) return false

    if (auth.isSuperUser) {
        return true
    }

    const authorizationList = userInfo['authorization_list']

    // handle two type component:
    const mainComp = id.split('.')[0] // member_search/bet_record
    const parentComp = mainComp.split('/')[0] //member_search
    if (authorizationList.includes(mainComp) || authorizationList.includes(parentComp)) {
        return true
    }
    return authorizationList.includes(id)
}

export function getRecommendationAuthMap() {
    const auth = store.getState().auth

    if (!auth) return {}

    const filteredAuthMap = {}

    Object.entries(AUTH.RecommendationAuthMap).forEach(([key, elem]) => {
        filteredAuthMap[key] = elem.filter(
            (action) => checkValid(action) && (auth.isAdmin || !(action.startsWith('role.') || action.startsWith('user.')))
        )
    })

    return filteredAuthMap
}


export function tempRemoveAuthorization(list) {
    const removeList = ['game_elastic_max_bet.view', 'historical_record.view']
    removeList.forEach(item => {
        if (list.includes(item)) {
            const removeItem = list.indexOf(item)
            list.splice(removeItem, 1)
        }
    })
}

export function filterRedundantAuthorization(parentAuthorization, selfAuthorization) {
    const _parent = []
    const _child = []
    parentAuthorization.forEach(group=>{
        group.children.forEach(child => {
            _parent.push(child.key)
        })
    })
    selfAuthorization.forEach(item=>{
        _parent.includes(item) && _child.push(item)
    })
    return _child
}